var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-goods-group',{ref:"tablePage",staticClass:"pt-goods-group__withData",on:{"deleteGroup":_vm.deleteGroup}})}
var staticRenderFns = []

export { render, staticRenderFns }